














import {
  computed,
  defineComponent,
  ref,
  watch,
} from '@vue/composition-api';

import useDelivery from '@/useDelivery';

const CommonDeliveryStatusSelect = defineComponent({
  props: {
    value: { default: '' },
    label: { default: '' },
    icon: { default: '' },
    placeholder: { default: 'เลือกสถานะ' },
    orderListPage: { default: false },
    excludeCancel: { default: false },
    small: { default: false },
  },
  setup(props: any) {
    const { english: en, thai: th } = useDelivery();
    const list = computed(() => {
      if (props.orderListPage) {
        if (props.excludeCancel) {
          return ['', ...en.slice(1)];
        }
        return ['', ...en.slice(1)];
      }
      return en.slice(3, 7);
    });
    const display = computed(() => {
      if (props.orderListPage) {
        if (props.excludeCancel) {
          return ['ทั้งหมด', ...th.slice(1)];
        }
        return ['ทั้งหมด', ...th.slice(1)];
      }
      return th.slice(3, 7);
    });
    const _value = ref('PENDING');
    watch(() => props.value, (newVal, oldVal) => {
      if (newVal !== oldVal && newVal !== _value.value) _value.value = newVal;
    });

    return {
      list,
      display,
      _value,
    };
  },
});

export default CommonDeliveryStatusSelect;
